import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaQuoteLeft, FaSave, FaTrash, FaPlus, FaEdit } from 'react-icons/fa';
import styles from './Admin.module.css';

const AdminTestimonials = () => {
  const [activeTab, setActiveTab] = useState('reviews'); // reviews, stats, cta
  const [data, setData] = useState({ reviews: [], stats: [], cta: {} });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  // Form States
  const [reviewForm, setReviewForm] = useState({
    id: 0, name: '', location: '', profession: '', rating: 5, text: '', systemSize: '3 kW', savingsPercent: '80%'
  });
  const [statForm, setStatForm] = useState({ id: 0, value: '', label: '' });



  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const res = await api.get('/Testimonials');
      setData(res.data);
    } catch (err) { console.error(err); }
  };

  // --- 1. REVIEWS ACTIONS ---
  const saveReview = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
     await api.post('/Testimonials/save-review', reviewForm);
      setMessage({ text: "Review Saved!", type: "success" });
      fetchData();
      setReviewForm({ id: 0, name: '', location: '', profession: '', rating: 5, text: '', systemSize: '', savingsPercent: '' });
    } catch (err) { setMessage({ text: "Error saving review", type: "error" }); }
    finally { setLoading(false); }
  };

  const deleteReview = async (id) => {
    if (!window.confirm("Delete this review?")) return;
    try {
      const token = localStorage.getItem('token');
     await api.delete(`/Testimonials/delete-review/${id}`);
      fetchData();
    } catch (err) { alert("Error deleting"); }
  };

  const editReview = (item) => {
    setReviewForm(item);
    window.scrollTo(0, 0);
  };

  // --- 2. STATS ACTIONS ---
  const saveStat = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
   await api.post('/Testimonials/save-stat', statForm);
      fetchData();
      setStatForm({ id: 0, value: '', label: '' }); // Clear form
    } catch (err) { alert("Error saving stat"); }
  };

  const editStat = (item) => {
    setStatForm(item);
  };

  // --- 3. CTA ACTIONS ---
  const handleCTAChange = (e) => {
    setData({ ...data, cta: { ...data.cta, [e.target.name]: e.target.value } });
  };

  const saveCTA = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
    await api.post('/Testimonials/update-cta', data.cta);
      setMessage({ text: "CTA Updated!", type: "success" });
    } catch (err) { setMessage({ text: "Error updating CTA", type: "error" }); }
    finally { setLoading(false); }
  };

  if (!data.cta) return <div style={{color:'white'}}>Loading...</div>;

  return (
    <div className={styles.formCard} style={{ maxWidth: '1000px' }}>
      <h3 style={{ marginBottom: '1.5rem', color: '#4ade80' }}><FaQuoteLeft /> Testimonials Management</h3>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '1px solid #444', paddingBottom: '10px' }}>
        {['reviews', 'stats', 'cta'].map(tab => (
          <button 
            key={tab} onClick={() => setActiveTab(tab)}
            style={{
              padding: '8px 20px', borderRadius: '5px', border: 'none', cursor: 'pointer', fontWeight: 'bold', textTransform: 'capitalize',
              background: activeTab === tab ? '#4ade80' : 'transparent', color: activeTab === tab ? '#000' : '#888'
            }}
          >
            {tab}
          </button>
        ))}
      </div>

      {message.text && <div style={{padding:'10px', marginBottom:'20px', background: message.type==='error'?'#ef444433':'#4ade8033', color: message.type==='error'?'#ef4444':'#4ade80', borderRadius:'5px'}}>{message.text}</div>}

      {/* --- TAB 1: REVIEWS --- */}
      {activeTab === 'reviews' && (
        <div>
          <form onSubmit={saveReview} style={{background:'#ffffff10', padding:'15px', borderRadius:'10px', marginBottom:'20px'}}>
            <h4 style={{color:'white', margin:'0 0 10px'}}>{reviewForm.id===0?'Add Review':'Edit Review'}</h4>
            <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px'}}>
              <input className={styles.formInput} placeholder="Name" value={reviewForm.name} onChange={e=>setReviewForm({...reviewForm, name:e.target.value})} required />
              <input className={styles.formInput} placeholder="Location (e.g. Patna)" value={reviewForm.location} onChange={e=>setReviewForm({...reviewForm, location:e.target.value})} required />
              <input className={styles.formInput} placeholder="Profession" value={reviewForm.profession} onChange={e=>setReviewForm({...reviewForm, profession:e.target.value})} />
              <input className={styles.formInput} type="number" min="1" max="5" placeholder="Rating (1-5)" value={reviewForm.rating} onChange={e=>setReviewForm({...reviewForm, rating:e.target.value})} required />
              <input className={styles.formInput} placeholder="System Size (3 kW)" value={reviewForm.systemSize} onChange={e=>setReviewForm({...reviewForm, systemSize:e.target.value})} />
              <input className={styles.formInput} placeholder="Savings (80%)" value={reviewForm.savingsPercent} onChange={e=>setReviewForm({...reviewForm, savingsPercent:e.target.value})} />
            </div>
            <textarea className={styles.formInput} style={{marginTop:'10px'}} placeholder="Review Text" value={reviewForm.text} onChange={e=>setReviewForm({...reviewForm, text:e.target.value})} rows="2" required />
            <button className={styles.primaryBtn} style={{marginTop:'10px'}} disabled={loading}><FaSave /> {reviewForm.id===0?'Add Review':'Update'}</button>
          </form>

          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px, 1fr))', gap:'15px'}}>
            {data.reviews.map(rev => (
              <div key={rev.id} style={{background:'#ffffff05', padding:'15px', borderRadius:'8px', borderTop:'3px solid #00D084'}}>
                <div style={{display:'flex', justifyContent:'space-between'}}>
                  <h5 style={{color:'white', margin:0}}>{rev.name}</h5>
                  <div style={{color:'#FFD700'}}>{"★".repeat(rev.rating)}</div>
                </div>
                <small style={{color:'#888'}}>{rev.location} | {rev.profession}</small>
                <p style={{color:'#ddd', fontSize:'0.9rem', margin:'5px 0'}}>{rev.text.substring(0, 80)}...</p>
                <div style={{display:'flex', gap:'10px', marginTop:'10px'}}>
                  <button onClick={()=>editReview(rev)} style={{color:'#4ade80', background:'none', border:'none', cursor:'pointer'}}>Edit</button>
                  <button onClick={()=>deleteReview(rev.id)} style={{color:'#ef4444', background:'none', border:'none', cursor:'pointer'}}>Delete</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* --- TAB 2: STATS --- */}
      {activeTab === 'stats' && (
        <div>
          <form onSubmit={saveStat} style={{background:'#ffffff10', padding:'15px', borderRadius:'10px', marginBottom:'20px', display:'flex', gap:'10px', alignItems:'end'}}>
            <div style={{flex:1}}><label style={{color:'#ccc'}}>Value (e.g. 500+)</label><input className={styles.formInput} value={statForm.value} onChange={e=>setStatForm({...statForm, value:e.target.value})} required /></div>
            <div style={{flex:2}}><label style={{color:'#ccc'}}>Label</label><input className={styles.formInput} value={statForm.label} onChange={e=>setStatForm({...statForm, label:e.target.value})} required /></div>
            <button className={styles.primaryBtn} style={{height:'42px'}}><FaSave /> Save</button>
          </form>

          {data.stats.map(stat => (
            <div key={stat.id} style={{display:'flex', justifyContent:'space-between', alignItems:'center', background:'#ffffff05', padding:'15px', marginBottom:'10px', borderRadius:'5px'}}>
              <h4 style={{color:'#4ade80', margin:0}}>{stat.value} <span style={{fontSize:'0.9rem', color:'#aaa', fontWeight:'normal'}}>{stat.label}</span></h4>
              <button onClick={()=>editStat(stat)} style={{color:'#4ade80', background:'none', border:'none', cursor:'pointer'}}><FaEdit /></button>
            </div>
          ))}
        </div>
      )}

      {/* --- TAB 3: CTA --- */}
      {activeTab === 'cta' && (
        <form onSubmit={saveCTA}>
          <div className={styles.formGroup}><label>Title</label><input className={styles.formInput} name="title" value={data.cta.title} onChange={handleCTAChange} /></div>
          <div className={styles.formGroup}><label>Description</label><input className={styles.formInput} name="description" value={data.cta.description} onChange={handleCTAChange} /></div>
          <div className={styles.formGroup}><label>Button Text</label><input className={styles.formInput} name="buttonText" value={data.cta.buttonText} onChange={handleCTAChange} /></div>
          <button className={styles.primaryBtn} disabled={loading}>{loading ? 'Saving...' : <><FaSave /> Update CTA</>}</button>
        </form>
      )}
    </div>
  );
};

export default AdminTestimonials;